import { useEffect } from 'react'

import { BASE_PAGING_STATE } from '../reduxes/slices/paging/reducers'
import {useLocalStorage} from "./use_local_storage";

export const REDUX_STORES_LS_KEY = 'redux_stores'

const KEYS_TO_SAVE = ['api', 'current', 'paging', 'related', 'replyTimelineId']
const ROOT_STORE_KEYS_TO_SAVE = ['api', 'current']

export const usePersistReduxStores = (
  rootStore: any,
  subStores: { [id: string]: any },
) => {
  const ls = useLocalStorage()

  useEffect(() => {
    const persist = () => {
      const subStoreStates = Object.keys(subStores).reduce(
        (acc: { [id: string]: any }, id) => {
          const state = subStores[id].getState()
          acc[id] = KEYS_TO_SAVE.reduce((acc: { [id: string]: any }, key) => {
            if (key === 'paging') {
              acc[key] = {
                ...BASE_PAGING_STATE,
                group_chats: state[key].group_chats,
                timelines: Object.keys(state[key].timelines).reduce(
                  (acc: any, topicId) => {
                    acc[topicId] = {
                      cachedBefore: state[key].timelines[topicId].cachedBefore,
                    }
                    return acc
                  },
                  {},
                ),
              }
            } else {
              acc[key] = state[key]
            }
            return acc
          }, {})
          return acc
        },
        {},
      )

      const state = rootStore.getState()
      const rootStoreState = ROOT_STORE_KEYS_TO_SAVE.reduce(
        (acc: { [id: string]: any }, key) => {
          acc[key] = state[key]
          return acc
        },
        {},
      )

      ls.setItem(
        REDUX_STORES_LS_KEY,
        {
          rootStore: rootStoreState,
          subStores: subStoreStates,
        },
      )
    }
    window.addEventListener('beforeunload', persist)
    return () => {
      window.removeEventListener('beforeunload', persist)
      persist()
    }
  }, [ls, rootStore, subStores])
}
